/* custom js scripts */
$(document).ready(function() {

    

    $('.moon-lang-selector span').on('click', function(){
        $('.moon-lang-selector ul').toggle();
    });


    // move circular color variant images after price
    $('.page-product .product-tax').parent().after($('.js-circular-thumbnails'));


    /*
    // reviews in detail
    if ($('body').hasClass('page-product')) {

        $('.page-product .product-section').after('<div class="moon-vingo-reviews"></div>');

        var sku = '';
        if ($('body').attr('data-product-var-first-sku')) {
            sku = $('body').attr('data-product-var-first-sku');
        }
        
        var lang = '';
        if ($('html').attr('lang')) {
            lang = $('html').attr('lang');
        }

        if ($('.moon-vingo-reviews').length) {
            $('.moon-vingo-reviews').load('https://vingosync.projects.manufactory.cz/vingo_reviews/slider.php?lang=' + lang + '&sku=' + sku);
        } 
    }
    // END reviews in detail
    */

    // USP badges
    if ($('body').hasClass('page-product')) {

        var lang = '';
        if ($('html').attr('lang')) {
            lang = $('html').attr('lang');
        }

        $('.page-product .product-info-wrapper .product-form').parent().parent().after(`<div class="usp">
                <img src="/cdn/shop/t/2/assets/usp_${lang}_1.png?v=3" alt="usp icon" />
                <img src="/cdn/shop/t/2/assets/usp_${lang}_2.png?v=3" alt="usp icon" />
                <img src="/cdn/shop/t/2/assets/usp_${lang}_3.png?v=3" alt="usp icon" />
                <img src="/cdn/shop/t/2/assets/usp_${lang}_4.png?v=3" alt="usp icon" />
            </div>`);
    }
    // END USP badges

    // trustedshops badge click event into GA
    $(document).on('click', '[id^="minimized-trustbadge-"]', function(){
        if (typeof gtag === 'function') {
            gtag('event', 'trustshops_badge_click', {
                'button_id': $(this).attr('id'),
                'page_location': window.location.href,
                'method': 'jquery_direct_push'
            });
        }
    });
    // END trustedshops badge click event into GA




    // append XXL badge to some variant options
    if ($('body').is('.page-product, .page-collection')) {

        let width, height;

        if ($('body').is('.category-663164059989')) { // bamboo blinds
            width = 150;
            height = 200;
        } else if ($('body').is('.category-663484957013')) { // wooden blinds
            width = 150;
            height = 200;
        } else if ($('body').is('.category-663190372693')) { // sunscreens
            width = 100;
            height = 198;
        } else if ($('body').is('.category-664284299605')) { // canopies
            width = 90;
            height = 500;
        } else {
            width = 150;
            height = 200;
        }

        const applyXxlBadges = () => {
            // Find all relevant fieldsets (standard product and quickview)
            $('fieldset.product-form-input').each(function() {
                const $this = $(this);
                // Target by index instead of text (0 is the first option)
                const optionIndex = $this.attr('data-option-index');

                if (optionIndex === '0') { 
                    $this.find('input[type="radio"]').each(function() {
                        const val = parseInt($(this).val());
                        if (!isNaN(val) && val >= width) {
                            $(this).next('label').addClass('has-xxl-badge');
                        }
                    });
                }

                if (optionIndex === '1') { 
                    $this.find('input[type="radio"]').each(function() {
                        const val = parseInt($(this).val());
                        if (!isNaN(val) && val >= height) {
                            $(this).next('label').addClass('has-xxl-badge');
                        }
                    });
                }
            });
        };

        // Initial run
        applyXxlBadges();

        // Observe body for dynamic popups and AJAX variant changes
        const observer = new MutationObserver((mutations) => {
            let shouldRun = false;
            mutations.forEach(mutation => {
                if (mutation.addedNodes.length || mutation.type === 'childList') {
                    shouldRun = true;
                }
            });

            if (shouldRun) {
                observer.disconnect();
                applyXxlBadges();
                observer.observe(document.body, { 
                    childList: true, 
                    subtree: true 
                });
            }
        });

        observer.observe(document.body, { 
            childList: true, 
            subtree: true 
        });
    }
    // END append XXL badge to some variant options


});

    

